var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiveHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.2C10 16.2 1.5 11.1 1.5 6.3C1.5 3.7 3.5 1.8 5.9 1.8C7.5 1.8 8.9 2.7 10 4C11.1 2.7 12.5 1.8 14.1 1.8C16.5 1.8 18.5 3.7 18.5 6.3C18.5 11.1 10 16.2 10 16.2Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiveHeart);
export default __webpack_public_path__ + "static/media/hive-heart.b2ce0ce74718ddeefedc0126efe99a76.svg";
export { ForwardRef as ReactComponent };